// Phone System Tour
// Numbers, calling, texting, registration and call handling
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_settings); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const phoneTour = {
  id: 'phone',
  name: 'Phone System Tour',
  displayName: 'Calls & Texts That Work',
  description: 'Numbers, calling, texting, registration and call handling',
  estimatedDuration: '4 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_settings',
      popover: {
        title: "📞 Welcome to the Phone System",
        description: `
          Your account can make calls and send texts from a real number — with every conversation saved against the contact. Let us set it up properly.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔢 Get a Number",
        description: `
          Buy a number in the area code you want, or bring an existing one across. Customers will recognise this number, so choose deliberately — changing it later is disruptive.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "✅ Register Before You Text",
        description: `
          Business texting requires **registration** before messages deliver reliably. Start it early: approval takes time, and unregistered messages fail **silently** — they look sent but never arrive.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📲 Calling",
        description: `
          Call from a contact record, from Conversations, or from the mobile app. Set **inbound routing** — who rings, for how long, and what the voicemail greeting says. Record a real greeting; defaults sound abandoned.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "💬 Messaging",
        description: `
          Texts get read, so keep them short, identify yourself, and give one clear next step. Only text people who agreed to it, and always honour an opt-out immediately.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎙️ Recording & Transcription",
        description: `
          Recorded calls attach to the contact and transcription makes them searchable. Tell callers you record where the law requires it — the greeting is the natural place.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "⚡ Automate the Follow-up",
        description: `
          The highest-return automation here: **text a missed caller back automatically**. Call events can also create tasks or start nurture sequences.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 You Are Connected",
        description: `
          You can now:

✅ Get a number and complete registration
✅ Handle inbound calls and voicemail
✅ Text compliantly
✅ Automate missed-call follow-up

**Next:** complete registration today so it is approved before you need it.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
